import { ref } from 'vue'
import type { ChatMessage } from '@/types/chat'

// Ref singleton em nível de módulo — mesmo padrão de useConversationStore.ts.
// Antes, ConvDrawer.vue, FocoView.vue e MobileView.vue mantinham cada um seu
// próprio Record<convId, ChatMessage[]> isolado (e FloatChatWindow.vue, um
// array por instância) — a mesma conversa aberta em mais de um desses lugares
// buscava o histórico de novo em cada um, com spinner cheio toda vez. Um único
// cache compartilhado por convId faz o primeiro a buscar "esquentar" os outros.
const _msgCache = ref<Record<number, ChatMessage[]>>({})

export function useMessageCache() {
  return { msgCache: _msgCache }
}

// Fase 4.2 do plano de otimização de login (mesmo padrão de
// resetConversationStore()) — chamado no logout pra não vazar mensagens de
// um agente pro próximo que logar na mesma aba.
export function resetMessageCache(): void {
  _msgCache.value = {}
}
